import axios from "axios";
import { API_BASE } from "../config";

export const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

const extractErrorMessage = (err, fallback) => {
  const data = err?.response?.data;

  // اگر سرور { error: "..."} یا { message: "..."} بده
  if (typeof data?.error === "string" && data.error.trim()) return data.error;
  if (typeof data?.message === "string" && data.message.trim()) return data.message;

  // اگر errors آبجکت باشد (mongoose validation)
  if (data?.errors && typeof data.errors === "object") {
    const msgs = Object.values(data.errors)
      .map((x) => x?.message || x?.msg || String(x))
      .filter(Boolean);
    if (msgs.length) return msgs.join(" | ");
  }

  // اگر data خودش string باشد
  if (typeof data === "string" && data.trim()) return data;

  // پیام خود axios
  if (typeof err?.message === "string" && err.message.trim()) return err.message;

  return fallback;
};

export const login = async (emailOrPhone, password, recaptchaToken) => {
  try {
    const response = await axios.post(`${API_BASE}auth/login`, {
      emailOrPhone,
      password,
      recaptchaToken,
    });
    return response.data;
  } catch (err) {
    console.error("خطا در ورود:", err);
    throw new Error(extractErrorMessage(err, "ورود ناموفق بود."));
  }
};

export const getMe = async () => {
  try {
    const res = await axios.get(`${API_BASE}users/me`, authHeaders());
    return res.data;
  } catch (err) {
    console.error("خطا در دریافت اطلاعات کاربر:", err);
    throw new Error(extractErrorMessage(err, "دریافت اطلاعات کاربر انجام نشد."));
  }
};

export const getUsers = async (filters = {}) => {
  try {
    const res = await axios.get(`${API_BASE}users`, {
      ...authHeaders(),
      params: filters,
    });
    return res.data;
  } catch (err) {
    console.error("خطا در دریافت کاربران:", err);
    throw new Error(extractErrorMessage(err, "دریافت لیست کاربران ناموفق بود."));
  }
};

export const createUser = async (data) => {
  try {
    const res = await axios.post(`${API_BASE}users`, data, authHeaders());
    return res.data;
  } catch (err) {
    console.error("خطا در ایجاد کاربر:", err);
    throw new Error(extractErrorMessage(err, "ایجاد کاربر با خطا مواجه شد."));
  }
};

export const updateUser = async (id, data) => {
  try {
    const res = await axios.put(`${API_BASE}users/${id}`, data, authHeaders());
    return res.data;
  } catch (err) {
    console.error("خطا در ویرایش کاربر:", err);
    throw new Error(extractErrorMessage(err, "ویرایش اطلاعات کاربر با خطا مواجه شد."));
  }
};

export const deleteUser = async (id) => {
  try {
    const res = await axios.delete(`${API_BASE}users/${id}`, authHeaders());
    return res.data;
  } catch (err) {
    console.error("خطا در حذف کاربر:", err);
    throw new Error(extractErrorMessage(err, "حذف کاربر با خطا مواجه شد."));
  }
};
